import { render, staticRenderFns } from "./FeaturedDesigner.vue?vue&type=template&id=9dd96b3e&scoped=true&lang=pug&"
import script from "./FeaturedDesigner.vue?vue&type=script&lang=js&"
export * from "./FeaturedDesigner.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedDesigner.vue?vue&type=style&index=0&id=9dd96b3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd96b3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9dd96b3e')) {
      api.createRecord('9dd96b3e', component.options)
    } else {
      api.reload('9dd96b3e', component.options)
    }
    module.hot.accept("./FeaturedDesigner.vue?vue&type=template&id=9dd96b3e&scoped=true&lang=pug&", function () {
      api.rerender('9dd96b3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/FeaturedDesigner.vue"
export default component.exports